var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yxtbiz-question-selector" },
    [
      _c("div", { staticClass: "yxtbiz-question-selector__treetable" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-question-selector__treetable-left" },
          [
            _c("catalogDropdown", {
              staticClass: "mt32 mb16",
              attrs: {
                data: _vm.datas,
                dropToolTip: _vm.$t("pc_biz_ote_lbl_classification"),
                catalogId: _vm.treeSearchData.catalogId,
                catalogName: _vm.treeSearchData.catalogName,
              },
              on: {
                "update:catalogId": function ($event) {
                  return _vm.$set(_vm.treeSearchData, "catalogId", $event)
                },
                "update:catalog-id": function ($event) {
                  return _vm.$set(_vm.treeSearchData, "catalogId", $event)
                },
                "update:catalogName": function ($event) {
                  return _vm.$set(_vm.treeSearchData, "catalogName", $event)
                },
                "update:catalog-name": function ($event) {
                  return _vm.$set(_vm.treeSearchData, "catalogName", $event)
                },
                change: _vm.catalogChange,
              },
            }),
            _c("yxt-input", {
              staticClass: "mb16",
              attrs: {
                disabled: _vm.treeLoading,
                placeholder: _vm.$t("pc_biz_ote_lbl_liborpoint"),
                "suffix-icon": "yxt-icon-search",
              },
              model: {
                value: _vm.treeSearchData.keywords,
                callback: function ($$v) {
                  _vm.$set(_vm.treeSearchData, "keywords", $$v)
                },
                expression: "treeSearchData.keywords",
              },
            }),
            _c("yxt-tree", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.treeLoading,
                  expression: "treeLoading",
                },
              ],
              ref: "tree",
              attrs: {
                "filter-node-method": _vm.filterNode,
                data: _vm.libandpointsData,
                "show-checkbox": "",
                "wrap-width": 236,
                "node-key": "id",
                virtual: "",
                props: _vm.defaultProps,
              },
              on: { check: _vm.handleCheckChange },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ node, data }) {
                    return _c(
                      "span",
                      { staticClass: "custom-tree-node" },
                      [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        data.shared === 1
                          ? _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  "max-width": 300,
                                  content:
                                    data.sharedFullname +
                                    _vm.$t("pc_biz_ote_btn_share"),
                                },
                              },
                              [
                                _c("yxt-svg", {
                                  staticClass: "hand vertical-align-middle",
                                  attrs: {
                                    "remote-url": _vm.svgRemote,
                                    "icon-class": "icon-share",
                                    width: "18px",
                                    height: "18px",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "yxtbiz-question-selector__treetable-right" },
          [
            _vm.multimedia
              ? _c(
                  "div",
                  { staticClass: "mt32 clearfix" },
                  [
                    _c("random-select", {
                      ref: "randomSelectRef",
                      attrs: {
                        pointIds: _vm.pointIdsArr,
                        quesTypes: _vm.quesTypes,
                      },
                      on: { setQuestion: _vm.setQuestion },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { class: [_vm.multimedia ? "mt16" : "mt32", "clearfix"] },
              [
                _c(
                  "yxt-select",
                  {
                    staticClass: "mr12 width144",
                    attrs: {
                      clearable: "",
                      size: "large",
                      placeholder: _vm.$t("pc_biz_ote_lbl_questiontype"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.filterAllQues(true)
                      },
                    },
                    model: {
                      value: _vm.quesSearchData._questionType,
                      callback: function ($$v) {
                        _vm.$set(_vm.quesSearchData, "_questionType", $$v)
                      },
                      expression: "quesSearchData._questionType",
                    },
                  },
                  _vm._l(_vm.typeList, function (item) {
                    return _c("yxt-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c(
                  "yxt-select",
                  {
                    staticClass: "mr12 width144",
                    attrs: {
                      clearable: "",
                      size: "large",
                      placeholder: _vm.$t("pc_biz_ote_lbl_queslevel"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.filterAllQues(true)
                      },
                    },
                    model: {
                      value: _vm.quesSearchData._levelType,
                      callback: function ($$v) {
                        _vm.$set(_vm.quesSearchData, "_levelType", $$v)
                      },
                      expression: "quesSearchData._levelType",
                    },
                  },
                  _vm._l(_vm.levelTypeList, function (item) {
                    return _c("yxt-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("yxt-input", {
                  staticClass: "width240",
                  attrs: {
                    size: "large",
                    searchable: "",
                    placeholder: _vm.$t("pc_biz_ote_lbl_searchques"),
                  },
                  on: {
                    search: function ($event) {
                      return _vm.filterAllQues(true)
                    },
                  },
                  model: {
                    value: _vm.quesSearchData.keyWord,
                    callback: function ($$v) {
                      _vm.$set(_vm.quesSearchData, "keyWord", $$v)
                    },
                    expression: "quesSearchData.keyWord",
                  },
                }),
              ],
              1
            ),
            _c(
              "yxt-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "examTable",
                staticClass: "mt16",
                attrs: { data: _vm.selectTableList, height: _vm.tableHeight },
                on: {
                  "select-all": _vm.quesSelectedOprateAll,
                  select: _vm.selectionChange,
                },
              },
              [
                _c("yxt-table-column", {
                  attrs: {
                    type: "selection",
                    "show-overflow-tooltip": false,
                    width: "38",
                    align: "right",
                    selectable: _vm.checkRowSelectable,
                    "class-name":
                      "yxtbiz-question-selector__treetable-checkbox",
                    "clear-padding": "left-right",
                  },
                }),
                _c("yxt-table-column", {
                  attrs: {
                    "show-overflow-tooltip": false,
                    label: _vm.$t("pc_biz_ote_lbl_quesname"),
                    prop: "summary",
                    "min-width": "170",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.summary
                            ? _c(
                                "div",
                                { staticClass: "yxtbiz-table-row" },
                                [
                                  _c("audio-video-icon", {
                                    staticClass: "mr5 vertical-align-middle",
                                    attrs: { type: scope.row.quesType },
                                  }),
                                  _c(
                                    "yxt-tooltip",
                                    {
                                      staticClass:
                                        "yxtbiz-table-row__name color-primary-6 hand",
                                      attrs: {
                                        "open-filter": "",
                                        "max-width": 300,
                                        effect: "dark",
                                        content: scope.row.summary,
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "ellipsis",
                                          class: {
                                            "color-bf cursor-normal":
                                              !_vm.checkRowSelectable(
                                                scope.row
                                              ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.oprate(scope.row, 2)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(scope.row.summary) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          !scope.row.summary
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.oprate(scope.row, 2)
                                    },
                                  },
                                },
                                [
                                  _c("audio-video-icon", {
                                    staticClass: "mr5 vertical-align-middle",
                                    attrs: { type: scope.row.quesType },
                                  }),
                                  _c("yxt-svg", {
                                    staticClass: "hand vertical-align-middle",
                                    attrs: {
                                      "remote-url": _vm.svgRemote,
                                      "icon-class": "ques-image",
                                      width: "20px",
                                      height: "20px",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "font-size-12 color-bf" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.isNull(scope.row.libName)) +
                                "\n            "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: _vm.$t("pc_biz_ote_lbl_assessmentpoint"),
                    prop: "pointNames",
                    width: "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "color-bf": !_vm.checkRowSelectable(scope.row),
                              },
                            },
                            [_vm._v(_vm._s(scope.row.pointNames))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    "show-overflow-tooltip": false,
                    label: _vm.$t("pc_biz_ote_lbl_questiontype"),
                    prop: "type",
                    width: "90",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "color-bf": !_vm.checkRowSelectable(scope.row),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getQuestionType(scope.row.type))
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    "show-overflow-tooltip": false,
                    label: _vm.$t("pc_biz_ote_lbl_queslevel"),
                    prop: "levelType",
                    width: "80",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                "color-bf": !_vm.checkRowSelectable(scope.row),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getQuestionLevalType(scope.row.levelType)
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c(
                  "yxt-row",
                  {
                    staticClass:
                      "mt16 text-right yxtbiz-question-selector__pager",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "yxtbiz-question-selector__pager-left" },
                      [
                        _c(
                          "yxt-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.selectTableList &&
                                  _vm.selectTableList.length,
                                expression:
                                  "selectTableList && selectTableList.length",
                              },
                            ],
                            attrs: {
                              loading: _vm.loadingAll,
                              type: "text",
                              size: "large",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addAllBasketData()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("pc_biz_ote_btn_allselect")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-question-selector__pager-right" },
                      [
                        _c("yxt-pagination", {
                          staticClass: "pull-right",
                          attrs: {
                            "page-size": _vm.pageSize,
                            total: _vm.selectTableListCount,
                            "current-page": _vm.currentPage,
                            "simple-total": "",
                            layout: "total, prev, pager, next",
                          },
                          on: { "current-change": _vm.handleCurrentChange },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "yxtbiz-question-selector__basket" }, [
          _c(
            "span",
            {
              staticClass: "yxtbiz-question-selector__basket-open",
              on: {
                click: function ($event) {
                  return _vm.openBasketBox()
                },
              },
            },
            [
              _c("yxt-svg", {
                attrs: {
                  "remote-url": _vm.svgRemote,
                  "icon-class": "exam-closeBacket",
                  width: "13px",
                  height: "10px",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "vertical-text hand",
              on: { click: _vm.openBasketBox },
            },
            [
              _c("div", { staticClass: "ml3 mr10" }, [
                _c(
                  "span",
                  { staticClass: "color-gray-8" },
                  [
                    _c(
                      "yxt-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          "max-width": 300,
                          content: _vm.$t("pc_biz_ote_lbl_quesbasket"),
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "yxt-badge",
                          {
                            staticClass: "item",
                            attrs: {
                              max: 999,
                              value: _vm.basketBoxData.selectData.length,
                            },
                          },
                          [
                            _c("yxt-svg", {
                              attrs: {
                                "remote-url": _vm.svgRemote,
                                "icon-class": "exam-backet",
                                width: "17px",
                                height: "16px",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _c(
        "yxt-drawer",
        {
          attrs: {
            size: "640px",
            title: _vm.$t("pc_biz_ote_lbl_quesbasket"),
            wrapperClosable: true,
            "append-to-body": true,
            "before-close": _vm.handleClose,
            visible: _vm.basketBoxData.isShow,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.basketBoxData, "isShow", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "yxtbiz-question-basket" }, [
            _c("div", { staticClass: "lh20 mb16" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("pc_biz_ote_lbl_chosenquestions")) +
                  "：\n        " +
                  _vm._s(_vm.basketBoxData.selectData.length) +
                  _vm._s(_vm.$t("pc_biz_ote_lbl_questi")) +
                  "\n      "
              ),
            ]),
            _c(
              "div",
              { staticClass: "mb16" },
              [
                _c(
                  "yxt-button",
                  {
                    attrs: { size: "large", plain: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.batchRemoveBasketData.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pc_biz_ote_btn_batchremove")) +
                        "\n        "
                    ),
                  ]
                ),
                _c(
                  "yxt-button",
                  {
                    attrs: { size: "large", plain: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.removeAllBasketData.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("pc_biz_ote_lbl_clearall")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {},
              [
                _c(
                  "yxt-select",
                  {
                    staticClass: "mr12 mb16 width144",
                    attrs: {
                      size: "large",
                      clearable: "",
                      placeholder: _vm.$t("pc_biz_ote_lbl_questiontype"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.getBasketSelectData()
                      },
                    },
                    model: {
                      value: _vm.basketBoxData.searchData._questionType,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.basketBoxData.searchData,
                          "_questionType",
                          $$v
                        )
                      },
                      expression: "basketBoxData.searchData._questionType",
                    },
                  },
                  _vm._l(_vm.typeList, function (item) {
                    return _c("yxt-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c(
                  "yxt-select",
                  {
                    staticClass: "mr12 mb16 width144",
                    attrs: {
                      size: "large",
                      clearable: "",
                      placeholder: _vm.$t("pc_biz_ote_lbl_queslevel"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.getBasketSelectData()
                      },
                    },
                    model: {
                      value: _vm.basketBoxData.searchData._levelType,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.basketBoxData.searchData,
                          "_levelType",
                          $$v
                        )
                      },
                      expression: "basketBoxData.searchData._levelType",
                    },
                  },
                  _vm._l(_vm.levelTypeList, function (item) {
                    return _c("yxt-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("yxt-input", {
                  staticClass: "mb16 width200",
                  attrs: {
                    size: "large",
                    searchable: "",
                    placeholder: _vm.$t("pc_biz_ote_lbl_searchques"),
                  },
                  on: { search: _vm.filterSelectedQues },
                  model: {
                    value: _vm.basketBoxData.searchData.keyWord,
                    callback: function ($$v) {
                      _vm.$set(_vm.basketBoxData.searchData, "keyWord", $$v)
                    },
                    expression: "basketBoxData.searchData.keyWord",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {},
              [
                _c(
                  "yxt-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "clazz_width_100",
                    attrs: {
                      data: _vm.basketBoxData.currentSelectData,
                      "default-sort": {
                        prop: "updateTime",
                        order: "descending",
                      },
                    },
                    on: { "selection-change": _vm.basketBoxSelectionChange },
                  },
                  [
                    _c("yxt-table-column", {
                      attrs: {
                        type: "selection",
                        "show-overflow-tooltip": false,
                        width: "38",
                        align: "right",
                        "clear-padding": "left-right",
                      },
                    }),
                    _c("yxt-table-column", {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_quesname"),
                        prop: "summary",
                        "show-overflow-tooltip": false,
                        "min-width": "300px",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.summary
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "yxtbiz-table-row",
                                      on: {
                                        click: function ($event) {
                                          return _vm.oprate(scope.row, 2)
                                        },
                                      },
                                    },
                                    [
                                      _c("audio-video-icon", {
                                        staticClass:
                                          "mr5 vertical-align-middle",
                                        attrs: { type: scope.row.quesType },
                                      }),
                                      _c(
                                        "yxt-tooltip",
                                        {
                                          staticClass:
                                            "yxtbiz-table-row__name color-primary-6 hand",
                                          attrs: {
                                            "open-filter": "",
                                            "max-width": 300,
                                            effect: "dark",
                                            content: scope.row.summary,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "ellipsis" },
                                            [_vm._v(_vm._s(scope.row.summary))]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !scope.row.summary
                                ? _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.oprate(scope.row, 2)
                                        },
                                      },
                                    },
                                    [
                                      _c("audio-video-icon", {
                                        staticClass:
                                          "mr5 vertical-align-middle",
                                        attrs: { type: scope.row.quesType },
                                      }),
                                      _c("yxt-svg", {
                                        staticClass:
                                          "hand vertical-align-middle",
                                        attrs: {
                                          "remote-url": _vm.svgRemote,
                                          "icon-class": "ques-image",
                                          width: "20px",
                                          height: "20px",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "font-size-12 color-bf" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.isNull(scope.row.libName)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("yxt-table-column", {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_btn_operate"),
                        align: "left",
                        width: "80",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "yxt-link",
                                {
                                  attrs: {
                                    underline: false,
                                    type:
                                      scope.row.status != 2
                                        ? "text"
                                        : "primary",
                                    disabled: scope.row.status != 2,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.quesSelectedOprate(
                                        scope.row,
                                        1
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("pc_biz_ote_btn_delete")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c(
                      "yxt-row",
                      { staticClass: "mt16 text-right lh30" },
                      [
                        _c("yxt-pagination", {
                          staticClass: "pull-right",
                          attrs: {
                            "page-size": _vm.basketBoxData.searchData.limit,
                            total: _vm.basketBoxData.filterData.length,
                            "current-page":
                              _vm.basketBoxData.searchData.current,
                            layout: "total, prev, pager, next",
                          },
                          on: { "current-change": _vm.quesHandleCurrentChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "yxt-drawer",
        {
          ref: "quesViewDrawer",
          attrs: {
            size: "640px",
            title: _vm.$t("pc_biz_ote_lbl_quesview"),
            visible: _vm.quesDetailData.dialogVisible,
            "before-close": _vm.handleClose,
            destroyOnClose: true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.quesDetailData, "dialogVisible", $event)
            },
          },
        },
        [_c("ques-view", { attrs: { id: _vm.quesDetailData.id } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }